import {
  getCurrentProjectAdminApiUrlById,
  getCurrentProjectWebApiUrlById,
} from '@helpers/projects';

import { ProjectsSelectProjectReducer } from './types';

export const projectsSelectProjectReducer: ProjectsSelectProjectReducer = (
  state,
  action
) => {
  const { projectId } = action.payload;

  const currentProject = state.projects.find(
    (project) => projectId === project.id
  );

  if (!currentProject) {
    return state;
  }

  return {
    ...state,
    currentProject,
    currentProjectWebApiUrl: getCurrentProjectWebApiUrlById(projectId),
    currentProjectAdminApiUrl: getCurrentProjectAdminApiUrlById(projectId),
  };
};
